import React, { useEffect, useState } from "react";

import DialogMessageProps from "../model/DialogMessageProps";
import { TypeDialogMessageEnum } from "../model/Enums/TypeDialogMessageEnum";
import ButtonStyles from "../styles/components/ButtonStyles";
import DialogStyles from "../styles/components/DialogStyles";
import Dialog from "./Dialog";
import {
    InformationModalIcon,
    SuccessModalIcon,
    WarningModalIcon,
} from "./Icons";
import HtmlToReact from "./HtmlToReact";

const { BtnPrimary, DefaultButtonLink, BtnCustom } = ButtonStyles;
const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

function DialogMessage({
    show,
    type,
    title,
    text,
    textButton = "OK",
    showPrimaryButton = true,
    textButtonClose,
    disableConfirmButton = false,
    children,
    onClose,
    isHtml = false,
    dialogClassName = "",
    style,
    size = "width-300",
    cardId,
    buttonCustom = false,
}: DialogMessageProps) {
    const [icon, setIcon] = useState<any>(null);

    const handleClose = (params?: any) => {
        onClose({
            confirmButton: Boolean(params?.confirmButton),
            cancelButton: Boolean(params?.cancelButton),
            closeButton: Boolean(
                !params?.confirmButton && !params?.cancelButton
            ),
            cardId,
        });
    };

    const textComponent = text && (
        <StyledModalText style={{ marginTop: "24px", marginBottom: "24px" }}>
            {text}
        </StyledModalText>
    );

    const textToRender =
        isHtml && text ? <HtmlToReact htmlString={text} /> : textComponent;

    useEffect(() => {
        if (!show) return;

        if (type === "success" || type === TypeDialogMessageEnum.Success) {
            setIcon(<SuccessModalIcon />);
        } else if (type === "error" || type === TypeDialogMessageEnum.Error) {
            setIcon(<InformationModalIcon />);
        } else if (type === TypeDialogMessageEnum.Warning) {
            setIcon(<WarningModalIcon />);
        } else {
            setIcon(null);
        }
    }, [show]);

    return (
        <Dialog
            openModal={show}
            onHide={handleClose}
            size={size}
            modalIcon={icon}
            dialogClassName={dialogClassName}
            style={style}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                {title}
            </StyledModalTitle>
            {textToRender}
            {children}
            {buttonCustom && (
                <StyledContainerButton>
                    <BtnCustom
                        disabled={disableConfirmButton}
                        onClick={() => {
                            handleClose({
                                confirmButton: true,
                            });
                        }}
                    >
                        {textButton}
                    </BtnCustom>
                </StyledContainerButton>
            )}
            {!buttonCustom && showPrimaryButton && (
                <StyledContainerButton>
                    <BtnPrimary
                        disabled={disableConfirmButton}
                        onClick={() => {
                            handleClose({
                                confirmButton: true,
                            });
                        }}
                    >
                        {textButton}
                    </BtnPrimary>
                </StyledContainerButton>
            )}
            {textButtonClose && (
                <StyledContainerButton>
                    <DefaultButtonLink
                        onClick={() => {
                            handleClose({
                                cancelButton: true,
                            });
                        }}
                    >
                        {textButtonClose}
                    </DefaultButtonLink>
                </StyledContainerButton>
            )}
        </Dialog>
    );
}

export default DialogMessage;
